export const goToMBALHome = () => {
  window.location.href = "https://www.mbageas.life";
};

export const goToLandingPage = ({ directUrl }: { directUrl: string }) => {
  window.location.href = directUrl;
};
